<app-floorplan-product-menu
  [title]="tooltipTextCentralStations"
  [hasConfigurations]="centralStations.length > 0"
  [visible]="floorplan.floorplanState.centralStationsVisible"
  [locked]="floorplan.floorplanState.centralStationsLocked"
  [itemTextVisible]="floorplan.floorplanState.centralStationsItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.centralStationsVisible = $event"
  (lockUpdate)="floorplan.floorplanState.centralStationsLocked = $event"
  (itemTextVisibilityUpdate)="updateCentralStationsItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="central-station"
>
  @for (centralStation of centralStations; track centralStation) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="centralStation"
        [imageUrl]="(getImageUrl$(centralStation) | async) || ''"
        [numberOfFloorplanItems]="floorplan.countPlacedCentralStations(centralStation)"
        [attachments]="[]"
        (add)="addCentralStation(centralStation)"
        (delete)="deleteCentralStation(centralStation)"
        (dragStart)="drag(centralStation)"
        editPath="central-station"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
